import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {
  AuctionLaneModel,
  AuctionLaneRequest,
  InspectionAccessoryDto,
  InspectionDataDto,
  InspectionImageDto,
  InventoryService,
  Organization,
  PostingDataRequestModel,
  PostingDataResponseModel,
  Valuation,
  VehicleOption,
  YellowLight,
  DateUtilsService,
  EditPostingState,
  SetInspectionUpdated,
  SetSelectedAuctionLane,
  ToggleSpinner,
  UpdatePosting,
  ExceptionType,
  NewPostingInspectionOption,
  PostingTypes,
  SavePostingFormButtonLabel,
  SubmitPostingEvent,
  ViwExceptionType,
  EditPostingService, LaunchDarklyService
} from 'remarketing-angular-library';
import {ActivatedRoute, Router} from '@angular/router';
import {get as _get} from 'lodash';
import {locationList} from '../../data/photos-location-list';
import { EditPostingUtilsService } from '../../services/edit-posting-utils.service';
import {
  postingIgnorableErrors,
  postingNonIgnorableErrorList,
  sellerNotEligibleToPostVinForLocation
} from '../../data/posting-error';
import {MultiErrorListModel, MultiErrorModalComponent} from '../multi-error-modal/multi-error-modal.component';
import {formatCurrency} from '../../../../../app/shared/utils/util';
import {AuctionLaneCode} from '../../data/auction-lane-code';
import {AuctionLaneSelectionModalComponent} from '../auction-lane-selection-modal/auction-lane-selection-modal.component';
import {TranslocoService} from '@jsverse/transloco';
import {ErrorModalComponent} from '@ally/remarketing/shared/ui';
import {take, takeUntil} from 'rxjs/operators';
import {SaComponent} from 'smartauction-frontend-micro-library';
import {FormTrackingModalComponent} from '../form-tracking-modal/form-tracking-modal.component';
import { TireValidationHelperService } from '../../services/tire-validation-helper.service';
import {PostingAnalyticsHelperService} from '../../services/posting-analytics-helper.service';
import { ProvinceErrorModalComponent } from '../province-error-modal/province-error-modal.component';


@Component({
    selector: 'app-edit-posting-buttons',
    templateUrl: './edit-posting-buttons.component.html',
    styleUrls: ['./edit-posting-buttons.component.scss'],
    imports: [MultiErrorModalComponent, AuctionLaneSelectionModalComponent, FormTrackingModalComponent, ErrorModalComponent, ProvinceErrorModalComponent]
})
export class EditPostingButtonsComponent extends SaComponent implements OnInit {
  @ViewChild(MultiErrorModalComponent) readonly multiErrorModal: MultiErrorModalComponent;
  @ViewChild(AuctionLaneSelectionModalComponent) auctionLaneSelection: AuctionLaneSelectionModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(FormTrackingModalComponent) formTrackingModal: FormTrackingModalComponent;
  @ViewChild(ProvinceErrorModalComponent) provinceRestrictionModal: ProvinceErrorModalComponent;

  @Input() isYellowLightChecked: boolean;
  @Output() continueSubmission = new EventEmitter<SubmitPostingEvent>();
  saveFormButtonLabel: SavePostingFormButtonLabel;
  analyticsSaveFormButtonLabel: string;
  postingErrorList: MultiErrorListModel[] = [];
  multiErrorHeaderTranslationKey: string;
  ignorableErrorCodeList = [];
  ignoreWarningList: string[] = [];
  repostSuccessHeading: string;
  repostSuccessContent: string;
  repostTranslateObj: any;
  generalErrorMessage: string;
  postingType: PostingTypes;
  textSelect: string;
  newPostingPendingInspectionSuccessHeader: string;
  newPostingPendingInspectionSuccessBody: string;
  newPostSuccessHeader: string;
  newPostSuccessContent: string;
  warningContent: string;
  postLimitTransObj: string;
  vin: string;
  readonly DIRECT_INSPECT_CONSTANT: string ='DirectInspect';
  readonly  DEFAULT_INSPECTION_COMPANY_ID = 'T99';
  readonly  DEFAULT_INSPECTION_CONDITION_GRADE = 9;

  editPostingButtonsTranslations = {
    saveFormButtonLabel: '',
    textCancelOfferAutobids: '',
    textOnlySelect: '',
    textSelectAllChange: '',
    cancel: ''
  };

  constructor(
    private readonly store: Store,
    private readonly inventoryService: InventoryService,
    private readonly editPostingUtilsService: EditPostingUtilsService,
    private readonly editPostingService: EditPostingService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly translocoService: TranslocoService,
    private readonly dateUtilService: DateUtilsService,
    private readonly tireValidationHelperService: TireValidationHelperService,
    private readonly postingAnalyticsHelperService: PostingAnalyticsHelperService,
    private readonly _launchDarklyService: LaunchDarklyService
  ) {
    super();
  }

  ngOnInit(): void {
    this.store.select(EditPostingState.postingType).pipe(takeUntil(super.destroyed$)).subscribe(postingType => {
      this.postingType = postingType;
      this.setPostingFormValues(postingType);
    });
    this.store.select(EditPostingState.originalPosting).pipe(takeUntil(super.destroyed$)).subscribe(originalPosting => {
      this.vin = originalPosting.inventoryItem?.vehicleInformation?.vin;
    });
    this.getTranslations();
  }

  setPostingFormValues(postingType: PostingTypes) {
    switch (postingType) {
    case PostingTypes.EDIT:
      this.saveFormButtonLabel = SavePostingFormButtonLabel.EDIT;
      this.analyticsSaveFormButtonLabel = 'Update Posting';
      break;
    case PostingTypes.NEW:
      this.saveFormButtonLabel = SavePostingFormButtonLabel.NEW;
      this.analyticsSaveFormButtonLabel = 'Post';
      break;
    case PostingTypes.REPOST_BEFORE_60_DAYS:
    case PostingTypes.REPOST_AFTER_60_DAYS:
      this.saveFormButtonLabel = SavePostingFormButtonLabel.REPOST;
      this.analyticsSaveFormButtonLabel = 'Repost';
      break;
    }
  }

  handleSubmitPosting() {
    this.editPostingUtilsService.displayFailedValidationForms();
    // We need to perform different actions based on a new posting/update/repost
    const requiredFieldsValid = this.checkRequestRequiredFields();
    if(this.postingType === PostingTypes.NEW) {
      if(requiredFieldsValid) {
        const allNewPostingFormsViewed = this.checkAllPostingFormsHaveBeenViewed();
        if(allNewPostingFormsViewed) {
          this.getAvailableAuctionLaneSelections();
        }
      }
    } else {
      if(requiredFieldsValid) {
        switch (this.postingType) {
        case PostingTypes.EDIT:
          this.submitPosting();
          break;
        case PostingTypes.REPOST_BEFORE_60_DAYS:
          this.getAvailableAuctionLaneSelections();
          break;
        default:
          return;
        }
      }
    }
  }

  /**
   *
   * @param postingData - updated posting data
   * If trimOptions is not there it updates the TRIM_NOT_SELECTED error code in ignoreWarnings metadata
   */
  updateIgnoreWarnings(postingData) {
    const trimArraylength = postingData.inventoryItem.vehicleOptions?.trimOptions?.length || 0;
    if (trimArraylength === 0) {
      this.ignoreWarningList.push('TRIM_NOT_SELECTED');
    }
  }

  submitPosting() {
    const postingData = this.store.selectSnapshot(EditPostingState.updatedPosting);
    this.updateIgnoreWarnings(postingData);
    const payload: PostingDataRequestModel = {
      data: postingData,
      metadata: {
        ignoreWarnings: this.ignoreWarningList,
        requestedBy: postingData.metadata?.requestedBy,
        lastModifiedTimeStampInMillis: postingData.metadata?.lastModifiedTimeStampInMillis,
        inspectionOption: this.postingType === PostingTypes.NEW ? this.store.selectSnapshot(EditPostingState.selectedInspectionOption) : null,
        inspectionUpdated: this.postingType === PostingTypes.EDIT ? this.store.selectSnapshot(EditPostingState.inspectionUpdated) : null
      }
    };

    this.updatePayloadForRequest(payload);
    this.updateRemovedOtherOptions(payload);
    this.checkPriceChange();

    console.log('[Posting] Final sellerOeUuid on submit:', payload?.data?.sellerOeUuid);

    this.store.dispatch(new ToggleSpinner());

    switch (this.postingType) {
    case PostingTypes.EDIT:
      this.putPostingData(postingData, payload);
      break;
    case PostingTypes.REPOST_BEFORE_60_DAYS:
      this.postPostingData(postingData, payload);
      break;
    case PostingTypes.NEW:
      this.submitNewPosting(postingData, payload);
      break;
    default:
      break;
    }
  }

  checkPriceChange(){
    try {
      const originalData = this.store.selectSnapshot(EditPostingState.originalPosting);
      const postingData = this.store.selectSnapshot(EditPostingState.updatedPosting);

      const originalOpeningPrice = originalData.inventoryItem.valuation?.openingPrice;
      const newOpeningPrice = postingData.inventoryItem.valuation.openingPrice;
      if(newOpeningPrice !== originalOpeningPrice){
        this.postingAnalyticsHelperService.trackPriceChangeEvent(
          'openingPriceChange', originalOpeningPrice, newOpeningPrice
        );
      }

      const originalBuyNowPrice = originalData.inventoryItem.valuation?.buyNowPrice;
      const newBuyNowPrice = postingData.inventoryItem.valuation.buyNowPrice;
      if(newBuyNowPrice !== originalBuyNowPrice){
        this.postingAnalyticsHelperService.trackPriceChangeEvent(
          'buyNowPriceChange', originalBuyNowPrice, newBuyNowPrice
        );
      }
    } catch (e) {
      console.log(e);
    }
  }

  checkAllPostingFormsHaveBeenViewed() : boolean {
    let allFormsViewed = undefined;
    const formSectionsWithUnviewedForms = this.store.selectSnapshot(EditPostingState.unViewedPostingForms);

    if(formSectionsWithUnviewedForms?.length > 0) {
      allFormsViewed = false;
      this.formTrackingModal.show(formSectionsWithUnviewedForms);
      this.postingAnalyticsHelperService.trackModalView('formTracking');
    } else {
      allFormsViewed = true;
    }

    return allFormsViewed;
  }

  checkRequestRequiredFields() {
    const errorList = [];
    const postingData = this.store.selectSnapshot(EditPostingState.updatedPosting);
    const tireFormsCertifiedOrValid = this.store.selectSnapshot(EditPostingState.tireFormsAreCertifiedOrValid);
    const modelCode = postingData.inventoryItem.vehicleInformation.model?.modelCode || null;
    const modelYear = isNaN(postingData.inventoryItem.vehicleInformation.modelYear);
    const makeCode = postingData.inventoryItem.vehicleInformation.make?.makeCode || null;
    const odometerMiles = postingData.inventoryItem.vehicleInformation.odometer || null;
    const storageLocationUuid = postingData.inventoryItem.storageLocation?.locationUuid || null;
    const yellowLights = postingData.inventoryItem.disclosures?.yellowLights;
    const valuation = postingData.inventoryItem.valuation;
    const vehicleType = postingData.inventoryItem.vehicleTypes?.find( (vh) => {
      return vh.selected;
    });
    const remainingDays = postingData.inventoryItem.postingInformation?.remainingDays;

    // 0 remaining days allowed on repost
    if(this.postingType === PostingTypes.EDIT && (remainingDays === 0 || remainingDays === null)){
      errorList.push({detail: 'INVALID_REMAINING_DAYS', parameters: {}});
    }

    if(!vehicleType){
      errorList.push({detail: 'INVALID_VEHICLE_TYPE', parameters: {}});
    }
    if (!this.validOpeningAndBuyNowPrice(valuation)) {
      errorList.push({detail: 'INVALID_PRICE', parameters: {}});
    }
    if (!this.isValidBuyNowPrice(valuation)) {
      errorList.push({detail: 'INVALID_BUY_NOW_PRICE_ERROR', parameters: {}});
    }
    if (this.isYellowLightChecked) {
      if (!this.validYellowLight(yellowLights)) {
        errorList.push({detail: 'INVALID_YELLOW_LIGHT', parameters: {}});
      }
    }
    if (!odometerMiles) {
      errorList.push({detail: 'INVALID_ODOMETER', parameters: {}});
    }
    if (!storageLocationUuid) {
      errorList.push({detail: 'INVALID_STORAGE_LOCATION_ADDRESS', parameters: {}});
    }

    if(!this.waitingForOrPendingInspection(postingData) && !tireFormsCertifiedOrValid
        && !this.tireValidationHelperService.isAllFourRequiredTiresDataPresent(postingData)) {
      errorList.push({detail: 'INVALID_TIRE_INFORMATION', parameters: {}});
    }

    // show error model if required fields are missing
    if(errorList.length) {
      this.multiErrorHeaderTranslationKey = 'nonIgnorableErrorModalheaderText';
      this.showMultiErrorModal(errorList);
      return false;
    }
    return true;
  }

  waitingForOrPendingInspection(postingData: PostingDataResponseModel): boolean {
    if(this.postingType === PostingTypes.NEW) {
      return this.isWaitForInspectionOption;
    } else {
      return this.isHoldAndPendingBatchInspection(postingData);
    }
  }

  get isWaitForInspectionOption(): boolean {
    const selectedInspectionOption = this.store.selectSnapshot(EditPostingState.selectedInspectionOption);
    return !!selectedInspectionOption && selectedInspectionOption === NewPostingInspectionOption.WAIT_FOR_INSPECTION ? true : false;
  }

  isHoldAndPendingBatchInspection(postingData: PostingDataResponseModel): boolean {
    return postingData?.inventoryItem?.itemStatus?.status === 'HOLD' &&
    postingData?.inventoryItem?.itemStatus?.statusReasons.filter(e => e.reasonDescription === 'Pending Batch Inspection' && e.statusCleared === false).length > 0;
  }

  getAvailableAuctionLaneSelections() {
    /*
    NOTE: When updating this method, it is not only used in this file but is also called from the template
          upon an emit from the form-tracking-modal.
    */
    const postingData = this.store.selectSnapshot(EditPostingState.updatedPosting);

    // Build the object with the parameters we'll need for our request
    const auctionLaneRequest: AuctionLaneRequest = {
      countryCode: 'US',  // Going to need to start returning this information with GET posting call and GET storage locations call
      titleStateCode: postingData.inventoryItem.titleState?.stateCode || null,
      modelCode: postingData.inventoryItem.vehicleInformation.model?.modelCode,
      modelYear: postingData.inventoryItem.vehicleInformation.modelYear,
      makeCode: postingData.inventoryItem.vehicleInformation.make?.makeCode,
      manufacturerCode: postingData.inventoryItem.vehicleInformation.make.vehicleManufacturerCode,
      classCode: postingData.inventoryItem.vehicleInformation.vehicleClass?.vehicleClassCode || null,
      typeCode: postingData.inventoryItem.vehicleTypes.filter(t => t.selected)[0]?.typeCode || null,
      odometer: postingData.inventoryItem.vehicleInformation.odometer,
      sellerOeUuid: postingData.sellerOeUuid || null,
      storageLocationUuid: postingData.inventoryItem.storageLocation.locationUuid
    };

    this.inventoryService.getAuctionLanes(auctionLaneRequest).pipe(take(1)).subscribe(response => {
      this.openAuctionLaneSelectionOrSuccessModal(response, postingData);
    }, error => {
      this.showGenericErrorModal();
    });
  }

  putPostingData(postingData: PostingDataResponseModel, payload: PostingDataRequestModel) {
    this.editPostingService.putPostingData(payload).pipe(take(1)).subscribe(response => {
      this.finishPostingSubmission(response);
    }, (error) => {
      this.store.dispatch(new ToggleSpinner());
      this.processErrorResponse(error);
    });
  }

  postPostingData(postingData: PostingDataResponseModel, payload: PostingDataRequestModel) {
    this.editPostingService.postPostingData(payload).pipe(take(1)).subscribe(response => {
      this.finishPostingSubmission(response);
    }, (error) => {
      this.store.dispatch(new ToggleSpinner());
      this.processErrorResponse(error);
    });
  }

  submitNewPosting(postingData: PostingDataResponseModel, payload: PostingDataRequestModel) {
    this.editPostingService.createNewPosting(payload).pipe(take(1)).subscribe(response => {
      this.finishPostingSubmission(response);
    }, (error) => {
      this.store.dispatch(new ToggleSpinner());
      this.processErrorResponse(error);
    });
  }

  finishPostingSubmission(response: any) {
    // Update our posting data to match the response
    this.store.dispatch([new UpdatePosting(response.data), new ToggleSpinner(), new SetInspectionUpdated(false)]);
    if (response?.data?.inventoryItem?.itemStatus?.statusReasons) {
      this.vin = response.data.inventoryItem.vehicleInformation.vin;
      const metPostLimitReason = response.data.inventoryItem.itemStatus.statusReasons.filter(r => !r.statusCleared && r.reasonDescription === 'Met Posting Limit');
      if (metPostLimitReason.length>0) {
        this.warningContent = this.postLimitTransObj;
      }
    }
    switch (this.postingType) {
    case PostingTypes.EDIT:
      this.continueSubmission.emit();
      break;
    case PostingTypes.NEW:
      this.setNewPostContent();
      this.continueSubmission.emit({
        header: this.newPostSuccessHeader,
        content: this.newPostSuccessContent,
        warningContent: this.warningContent
      });
      break;
    case PostingTypes.REPOST_AFTER_60_DAYS:
    case PostingTypes.REPOST_BEFORE_60_DAYS:
      this.setCreatePostingSuccessModalData();
      this.continueSubmission.emit({
        header: this.repostSuccessHeading,
        content: this.repostSuccessContent,
        warningContent: this.warningContent
      });
      break;
    }
  }

  setNewPostContent(){
    if(this.isWaitForInspectionOption) {
      this.newPostSuccessContent = this.newPostingPendingInspectionSuccessBody;
      this.newPostSuccessHeader = this.newPostingPendingInspectionSuccessHeader;
    } else {
      const selectedAuction = this.store.selectSnapshot(EditPostingState.selectedAuctionLane);

      const startTime = this.dateUtilService.localizeTime(selectedAuction.auctionStartTime);
      const endTime = this.dateUtilService.localizeTime(selectedAuction.auctionEndTime, true);
      const endDate = this.dateUtilService.localizeDate(selectedAuction.auctionEndTime);
      this.newPostSuccessContent = `${this.repostTranslateObj.success.textThe} ${this.repostTranslateObj.auctionSelection[selectedAuction.auctionCode]} ` +
        `${this.repostTranslateObj.success.textIsOn} ${endDate} ${this.repostTranslateObj.success.textFrom} ${startTime} - ${endTime}.`;
    }
  }

  /**
   *
   * @param yellowLightList - list of yellow light selections
   * returns true if any option is selected, false otherwise
   */
  validYellowLight(yellowLightList: YellowLight[]): boolean {
    return yellowLightList.some(light => light.selected === true);
  }

  /**
   * Check opening & buy now price are in multiples of 100
   *
   * @param valuation - posting data valuation
   * return true if valuation is valid, false otherwise
   */
  validOpeningAndBuyNowPrice(valuation: Valuation): boolean {
    const openingPrice = valuation?.openingPrice || null;
    const buyNowPrice = valuation?.buyNowPrice || null;
    // if buyNowPrice is undefined, only evaluate openingPrice
    return buyNowPrice !== null ? (this.isValidPrice(openingPrice) && this.isValidPrice(buyNowPrice))
      : this.isValidPrice(openingPrice);
  }

  isValidPrice(price: number): boolean {
    return price % 100 === 0 && price !== 0 && price !== null && price !== undefined;
  }

  isValidBuyNowPrice(valuation: Valuation): boolean {
    const openingPrice = valuation?.openingPrice;
    const buyNowPrice = valuation?.buyNowPrice;

    return buyNowPrice == null ? true : buyNowPrice >= openingPrice;
  }

  /**
   *
   * @param error - posting response error data
   * Filters the required errors from postingNonIgnorableErrorList and postingIgnorableErrors
   */
  processErrorResponse(error) {
    let nonIgnorableErrList = [];
    let ignorableErrList = [];
    let provincialRestrictionError;
    if (error?.error?.errors?.length) {
      nonIgnorableErrList = error.error.errors.filter((item) => {
        return postingNonIgnorableErrorList.includes(item.detail);
      });
      ignorableErrList = error.error.errors.filter((item) => {
        return postingIgnorableErrors.includes(item.detail);
      });
      error.error.errors.filter((item) => {
        if (item.detail === sellerNotEligibleToPostVinForLocation) {
          provincialRestrictionError = true;
        }
      });
    }
    if (this.isProvincialRestrictionsEnabled && provincialRestrictionError === true) {
      this.provinceRestrictionModal.show();
    } else {
      this.configureMultiErrorModal(nonIgnorableErrList, ignorableErrList);
    }
  }

  /**
   *
   * @param nonIgnorableErrCodeList - ignorable error list
   * @param ignorableErrCodeList - non-ignorable error list
   * assign respective modal header text and show modal
   */
  configureMultiErrorModal(nonIgnorableErrList, ignorableErrList) {
    if (nonIgnorableErrList.length) {
      this.multiErrorHeaderTranslationKey = 'nonIgnorableErrorModalheaderText';
      this.showMultiErrorModal(nonIgnorableErrList);
    } else if (ignorableErrList.length) {
      this.multiErrorHeaderTranslationKey = 'ignorableErrorModalheaderText';
      this.ignorableErrorCodeList = ignorableErrList.map((item) => {
        return item.detail;
      });
      this.showMultiErrorModal(ignorableErrList);
    } else {
      this.showGenericErrorModal();
    }
  }

  showGenericErrorModal() {
    this.errorModal.message = this.generalErrorMessage;
    this.errorModal.show();
    this.postingAnalyticsHelperService.trackModalView('genericError');
  }

  /**
   * sets formatted error list and show the modal
   */
  showMultiErrorModal(errorList) {
    this.postingErrorList = errorList.map((item) => {
      if (item.parameters?.amount) {
        item.parameters.amount = formatCurrency(item.parameters.amount);
      }
      if (item.parameters?.percentage) {
        item.parameters.percentage = parseFloat(item.parameters.percentage);
      }
      return {
        errCode: item.detail,
        parameters: this.multiErrorModal.constructTranslationDynamicParams(item.parameters)
      };
    });
    this.multiErrorModal.show();
    this.postingAnalyticsHelperService.trackMultiErrorModal(this.getErrorDetailList(errorList));
  }

  getErrorDetailList(errorList): string[]{
    const result = [];
    errorList.forEach(error => {
      result.push(error.detail);
    });
    return result;
  }

  /*
  Updates the payload of a posting request to add/remove fields as needed
  Various fields need to be altered/sent as null to accommodate 2.0 and VIW
   */
  updatePayloadForRequest(payload: PostingDataRequestModel) {
    const vehicleInfo = payload.data.inventoryItem.vehicleInformation;
    const vehicleOptions = payload.data.inventoryItem.vehicleOptions;
    const org = this.store.selectSnapshot(_state => _get(_state, 'org.organization', {} as Organization));

    console.log('[Posting] sellerOeUuid on request:', payload?.data?.sellerOeUuid, '| org.oeUuid:', org?.oeUuid);

    if (!payload?.data?.sellerOeUuid && org?.oeUuid) {
      console.log('[Posting] sellerOeUuid missing from request, populating from org state:', org.oeUuid);
      payload.data.sellerOeUuid = org.oeUuid;
    }

    this.handleNoTitleSelected(payload);
    const inspection = payload.data.inventoryItem.inspectionReport.inspectionData || {};
    this.updateInspectionFieldsForViw(inspection);
    inspection.dealerNumber = org.oeUuid.replaceAll('-', '').substring(0, 29);
    this.handleCostTotalsAndUpdateTireInformation(inspection);

    // Vehicle
    const vehicle = inspection.vehicle || {};
    vehicle.year = vehicleInfo.modelYear;
    vehicle.make = vehicleInfo.make?.makeDescription;
    vehicle.model = vehicleInfo.model?.modelDescription;
    vehicle.series = vehicleInfo.series ? vehicleInfo.series.seriesDescription : 'N/A';
    vehicle.exteriorColor = vehicleOptions.exteriorColors?.filter(x => x.installed === true).length > 0 ?
      vehicleOptions.exteriorColors.filter(x => x.installed === true)[0].shortDescription : 'N/A';
    vehicle.interiorColor = vehicleOptions.interiorColors?.filter(x => x.installed === true).length > 0 ?
      vehicleOptions.interiorColors.filter(x => x.installed === true)[0].shortDescription : 'N/A';
    vehicle.mileage = vehicleInfo.odometer;
    vehicle.interiorMaterial = vehicleOptions.interiorTypes?.filter(x => x.installed === true).length > 0 ?
      vehicleOptions.interiorTypes.filter(x => x.installed === true)[0].userFriendlyDescription?.substring(0, 10) : 'N/A';
    vehicle.vin = vehicleInfo.vin;

    if (vehicle.accessories && vehicle.accessories.length > 0) {
      vehicle.accessories = vehicle.accessories.map(accessory => this.replaceNonExistentDescription(accessory));
    }

    delete vehicle.licensePlate;
    delete vehicle.licenseState;

    // Extended Attributes
    const extended = inspection.extendedAttributes || {};
    if(!extended.dataProvider){
      extended.dataProvider = this.DIRECT_INSPECT_CONSTANT;
    }

    delete extended.owner;
    delete extended.newPosting;
    delete extended.postingPrice;
    delete extended.titleState;
    delete extended.subOwner;
    delete extended.accountType;

    // Inspection Flags
    const flags = inspection.inspectionFlags || {};
    delete flags.odomTampering;
    delete flags.singleOccurenceDamage;
    delete flags.upfitIndicator;
    delete flags.letteringIndicator;
    delete flags.plateDisposition;
    delete flags.yellowLightWarn;

    // Images
    this.updateImagePayloads(inspection);

    // Valuation
    const valuation = payload.data.inventoryItem.valuation;
    if (valuation?.buyNowPrice === null) {
      delete valuation.buyNowPrice;
    }
  }

  private updateInspectionFieldsForViw(inspection: InspectionDataDto) {
    delete inspection.viwSource;
    delete inspection.account;
    delete inspection.dateReturned;
    delete inspection.dealerName;
    delete inspection.dealerAddress;
    delete inspection.dealerAddress2;
    delete inspection.dealerCity;
    delete inspection.dealerState;
    delete inspection.dealerZip;
    delete inspection.dealerPhone;
    delete inspection.inspectorId;
    delete inspection.inspectionRequestDate;

    if (this.postingType === PostingTypes.EDIT && !this.store.selectSnapshot(EditPostingState.inspectionUpdated)) {
      // While EDITING if there are no changes to the inspection report, we want to preserve the original inspection fields if they are present.
      inspection.inspectionCompanyId = inspection.inspectionCompanyId || this.DEFAULT_INSPECTION_COMPANY_ID;
      inspection.conditionGrade = inspection.conditionGrade || this.DEFAULT_INSPECTION_CONDITION_GRADE;
      inspection.inspectionDate = inspection.inspectionDate || new Date().toISOString();
      inspection.statusDate = inspection.statusDate || new Date().toISOString();
      inspection.inspectionCompany = inspection.inspectionCompany || this.DIRECT_INSPECT_CONSTANT;
    } else {
      // For all posting flows other than edit posting with no inspection changes, we override inspection company fields.
      delete inspection.vinGuid;
      inspection.inspectionCompanyId = this.DEFAULT_INSPECTION_COMPANY_ID;
      inspection.conditionGrade = this.DEFAULT_INSPECTION_CONDITION_GRADE;
      inspection.inspectionDate = new Date().toISOString();
      inspection.statusDate = new Date().toISOString();
      inspection.inspectionCompany = this.DIRECT_INSPECT_CONSTANT;
    }
  }

  private updateImagePayloads(inspection: InspectionDataDto) {
    inspection.images?.forEach(x => {
      this.processImageData(x);
    });

    inspection.vehicle?.tires?.forEach(t => {
      t.tireImages?.forEach(x => {
        x.location = t.location;
        this.processImageData(x);
      });
      // VIW errors if we send null
      if (t.tireImages === null) {
        delete t.tireImages;
      }
    });

    inspection.exceptions?.forEach(e => {
      e.exceptionImages?.forEach(x => {
        this.processImageData(x);
      });
      // VIW errors if we send null
      if (e.exceptionImages === null) {
        delete e.exceptionImages;
      }
    });
  }

  handleNoTitleSelected(payload: PostingDataRequestModel){
    const titleState = payload.data.inventoryItem.titleState;
    const nullState = {
      name: this.textSelect,
      abbr: '--'
    };

    if (titleState?.stateCode.includes(nullState.abbr)) {
      payload.data.inventoryItem.titleState = null;
    }
  }

  replaceNonExistentDescription(accessory: InspectionAccessoryDto) {
    if (accessory.description === null || accessory.description === undefined) {
      accessory.description = '';
      return accessory;
    } else {
      return accessory;
    }
  }

  handleCostTotalsAndUpdateTireInformation(inspection: InspectionDataDto) {
    let tireTotal = 0;
    const tiresWithTread = [];
    inspection.vehicle?.tires?.forEach(x => {
      if (x.damageCost) {
        tireTotal += x.damageCost;
      }
      // Tire tread depth is mandatory attribute and so need to filter out records without tread depth
      if (x.tread) {
        tiresWithTread.push(x);
      }
    });
    if (inspection.vehicle && inspection.vehicle.tires) {
      // inspection.vehicle.tires = tiresWithTread;
      inspection.vehicle.tires = tiresWithTread;
    }
    let damageChargeableTotal = 0;
    let damageNonChargeableTotal = 0;
    inspection.exceptions?.forEach(x => {
      x.type = this.getViwExceptionType(x.type);
      if (x.chargeableFlag) {
        damageChargeableTotal += x.total;
      } else {
        damageNonChargeableTotal += x.total;
      }
    });

    // The chargeable total is equal to the cost of chargeable damages and cost of tire repairs
    inspection.chargeableTotal = tireTotal + damageChargeableTotal;
    inspection.nonChargeableTotal = damageNonChargeableTotal;
    inspection.total = inspection.chargeableTotal + inspection.nonChargeableTotal;
  }

  getViwExceptionType(exception: string) {
    switch (exception) {
    case ExceptionType.EQUIPMENT:
      return ViwExceptionType.EQUIPMENT;
    case ExceptionType.GLASS:
      return ViwExceptionType.GLASS;
    case ExceptionType.INTERIOR:
      return ViwExceptionType.INTERIOR;
    case ExceptionType.MECHANICAL:
      return ViwExceptionType.MECHANICAL;
    case ExceptionType.OTHER:
      return ViwExceptionType.OTHER;
    case ExceptionType.REPAIRS:
      return ViwExceptionType.REPAIRS;
    case ExceptionType.WHEELS:
      return ViwExceptionType.WHEELS;
    case ExceptionType.EXTERIOR:
      return ViwExceptionType.EXTERIOR;
    default:
      return exception;
    }
  }

  getViwLocationCode(location: string) {
    return locationList.filter(x => x.code === location).length > 0 ?
      locationList.filter(x => x.code === location)[0].code : location;
  }

  // Add sourceUrl if it is not present on image and populate image location.
  // Image payload modifications to meet VIW requirements (removing sourceUrl and fileName) have been moved to backend.
  processImageData(image: InspectionImageDto) {
    // Existing images need to have their sourceUrl property set, newly uploaded images will already have it
    if (!image.sourceUrl && image.url) {
      if (image.url.includes('az32078.vo.msecnd.net') || image.url.includes('inspections.ally.com')) {
        // Images from this domain need _large appended to the file name
        const fileParts = image.url.split('.');
        fileParts[fileParts.length - 2] += '_large';
        image.sourceUrl = fileParts.join('.');
      } else {
        image.sourceUrl = image.url;
      }
    }
    image.location = this.getViwLocationCode(image.location);
  }

  onCancel() {
    this.router.navigate(['/inventory']);
  }

  showCancelOffers() {
    return this.store.selectSnapshot(EditPostingState.postingType) === PostingTypes.EDIT;
  }

  updateRemovedOtherOptions(payload: PostingDataRequestModel) {
    // Get original otherOptions for Exterior, Interior and mechanical forms.
    const originalPostingData = this.store.selectSnapshot(EditPostingState.originalPosting);
    const originalOtherOptionsInterior = originalPostingData.inventoryItem.vehicleOptions.interiorOptions;
    const originalOtherOptionsExterior = originalPostingData.inventoryItem.vehicleOptions.exteriorOptions.otherOptions;
    const originalOtherOptionsMechanical = originalPostingData.inventoryItem.vehicleOptions.mechanicalOptions.otherOptions;

    // Update removed otherOptions for interior form
    Object.keys(originalOtherOptionsInterior).forEach(key => {
      const updatedInteriorOptions = payload.data.inventoryItem.vehicleOptions.interiorOptions[key];

      payload.data.inventoryItem.vehicleOptions.interiorOptions[key] = this.updateOtherOptions(updatedInteriorOptions, originalOtherOptionsInterior[key]);
    });

    // Update removed otherOptions for exterior form
    const updatedExteriorOptions = payload.data.inventoryItem.vehicleOptions.exteriorOptions.otherOptions;
    payload.data.inventoryItem.vehicleOptions.exteriorOptions.otherOptions = this.updateOtherOptions(updatedExteriorOptions, originalOtherOptionsExterior);


    // Update removed otherOptions for mechanical form
    const updatedMechanicalOptions = payload.data.inventoryItem.vehicleOptions.mechanicalOptions.otherOptions;
    payload.data.inventoryItem.vehicleOptions.mechanicalOptions.otherOptions = this.updateOtherOptions(updatedMechanicalOptions, originalOtherOptionsMechanical);
  }

  updateOtherOptions(updatedOptions: VehicleOption[], originalOptions: VehicleOption[]) {
    let removedOptions = originalOptions?.filter((option) => !updatedOptions?.find(({optionCode}) => option.optionCode === optionCode));
    removedOptions = removedOptions?.map(option => ({...option, installed: false}));
    return (updatedOptions || []).concat(removedOptions || []);
  }

  /**
   *
   * @param postAgain - boolean value
   * reset the warnings and trigger posting again
   */
  continuePostingVehicle(postAgain) {
    if (postAgain && this.ignorableErrorCodeList?.length) {
      this.ignoreWarningList = this.ignorableErrorCodeList;
      this.submitPosting();
    }
  }

  openAuctionLaneSelectionOrSuccessModal(auctionLanes: AuctionLaneModel[], postingData: PostingDataResponseModel) {
    if (auctionLanes.length === 1) {
      postingData.inventoryItem.auctionUuid = auctionLanes[0].auctionUuid;
      this.store.dispatch(new SetSelectedAuctionLane(auctionLanes[0]));
      this.store.dispatch(new UpdatePosting(postingData));
      this.submitPosting();
    } else {
      auctionLanes.sort((a, b) => (a.auctionStartTime < b.auctionStartTime ? -1 : 1));
      this.auctionLaneSelection.auctionLaneData = this.getAuctionLaneData(auctionLanes);
      this.auctionLaneSelection.auctionLaneOptions = auctionLanes;
      this.auctionLaneSelection.show();
      this.postingAnalyticsHelperService.trackModalView('auctionLaneSelection');
    }
  }

  getAuctionLaneData(auctionLanes: AuctionLaneModel[]) {
    return auctionLanes.map(auction => {
      let auctionDescription: string;
      const endDate = this.dateUtilService.localizeDate(auction.auctionEndTime);
      const startDate = this.dateUtilService.localizeDate(auction.auctionStartTime);
      if (auction.auctionCode === AuctionLaneCode.CURRENT_AUCTION || auction.auctionCode === AuctionLaneCode.TODAYS_AUCTION) {
        const endTime = this.dateUtilService.localizeTime(auction.auctionEndTime, true);
        auctionDescription = `${endDate} ${this.repostTranslateObj.auctionSelection.textEndsAt} ${endTime}`;
      } else {
        const startTime = this.dateUtilService.localizeTime(auction.auctionStartTime, true);
        auctionDescription = `${startDate} ${this.repostTranslateObj.auctionSelection.textStartingAt} ${startTime}`;
      }
      return {
        code: auction.auctionCode,
        name: auction.auctionName,
        description: auctionDescription,
        uuid: auction.auctionUuid
      };
    });
  }

  setCreatePostingSuccessModalData() {
    const selectedAuction = this.store.selectSnapshot(EditPostingState.selectedAuctionLane);
    const vin = this.store.selectSnapshot(EditPostingState.updatedPosting).inventoryItem.vehicleInformation.vin;

    if (selectedAuction.auctionCode === AuctionLaneCode.TODAYS_AUCTION) {
      this.repostSuccessHeading = `VIN ${vin} ${this.repostTranslateObj.success.todaysAuctionHeading} ${selectedAuction.auctionName} ${this.repostTranslateObj.success.auction}.`;
    } else {
      this.repostSuccessHeading = `VIN ${vin} ${this.repostTranslateObj.success.otherAuctionHeading} ${selectedAuction.auctionName} ${this.repostTranslateObj.success.auction}.`;
    }

    const endTime = this.dateUtilService.localizeTime(selectedAuction.auctionEndTime, true);
    const endDate = this.dateUtilService.localizeDate(selectedAuction.auctionEndTime);
    if (selectedAuction.auctionCode === AuctionLaneCode.CURRENT_AUCTION) {
      this.repostSuccessContent = `${this.repostTranslateObj.success.currentAuctionContent} ${endDate} ${this.repostTranslateObj.success.textAt} ${endTime}`;
    } else {
      const startTime = this.dateUtilService.localizeTime(selectedAuction.auctionStartTime);
      this.repostSuccessContent = `${this.repostTranslateObj.success.otherAuctionContent} ${endDate} ${this.repostTranslateObj.success.textFrom} ${startTime} - ${endTime}.`;
    }
  }

  getTranslations() {
    const keyParams = {
      'sellModule.posting': {},
      'common': {}
    };

    // Data translations
    this.translocoService.selectTranslateObject('sellModule.posting', {
      'postingSuccessModal.textNewPostingSuccessHeaderHold': {vin: this.vin},
      'postingSuccessModal.textPostMetPostingLimit': {vin: this.vin}
    }).pipe(takeUntil(super.destroyed$)).subscribe(translatedObj => {
      this.repostTranslateObj = translatedObj.repostModal;
      this.generalErrorMessage = translatedObj.multiErrorModal.GENERAL_ERROR;
      this.textSelect = translatedObj.damagesForm.textSelect;
      this.postLimitTransObj = translatedObj.postingSuccessModal.textPostMetPostingLimit;
      this.newPostingPendingInspectionSuccessBody = translatedObj.postingSuccessModal.textNewPostingSuccessBody;
      this.newPostingPendingInspectionSuccessHeader = translatedObj.postingSuccessModal.textNewPostingSuccessHeaderHold;
    });

    // DOM translations
    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(super.destroyed$)).subscribe(translate => {
      this.editPostingButtonsTranslations.saveFormButtonLabel = translate[0].editPostingEnum[this.saveFormButtonLabel];
      this.editPostingButtonsTranslations.textCancelOfferAutobids = translate[0].editPostingButtons.textCancelOfferAutobids;
      this.editPostingButtonsTranslations.textOnlySelect = translate[0].editPostingButtons.textOnlyselect;
      this.editPostingButtonsTranslations.textSelectAllChange = translate[0].editPostingButtons.textSelectAllChange;
      this.editPostingButtonsTranslations.cancel = translate[1].btnCancel;
    });
  }

  get isProvincialRestrictionsEnabled() {
    return this._launchDarklyService.getFeatureFlag('posting-provincialRestrictionsEnabled', false);
  }
}
